import Swal from 'sweetalert2';
import styled from 'styled-components';
import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import NewVbfBoardForm from './Form.jsx';
import Modal from '../../../../shared/Modal';
import { createVbfBoard } from '../../data';
import { Button } from '../../../../shared/FormStyles';
import { useNotification } from '../../../../shared/Notification/useNotification';
import defaultAttrs from '../../../../lib/utils/defaultAttrs';

const Airbo = window.Airbo || {};

const NewFairIcon = styled.i.attrs(
  defaultAttrs({
    className: 'fa-solid fa-plus',
  }),
)`
  margin: 0 6px 0 0;
`;

const CreateCampaignButton = ({ templateList }) => {
  const { showSuccess } = useNotification();
  const { t } = useTranslation(['shared', 'clients']);
  const { mutate } = useMutation(createVbfBoard, {
    onSuccess: () => {
      showSuccess({
        content: t('clients:clientsTable:pending'),
        title: t('clients:clientsTable:create'),
      });
      Swal.close();
    },
  });

  const modalForm = () => {
    Airbo.Utils.ping('Click Create New Board', {
      tab: Airbo.Utils.currentTab(),
      organization: Airbo.Utils.currentOrganization(),
    });

    Modal({
      component: (
        <NewVbfBoardForm
          templateList={templateList}
          handleCancel={Swal.clickCancel}
          mutate={mutate}
        />
      ),
      width: '394px',
      padding: '24px 13px',
    });
  };

  return (
    <Button variant="outlinedBlue" padding="11px 16px" onClick={modalForm}>
      <NewFairIcon /> {t('clients:clientsTable:createCampaign')}
    </Button>
  );
};

export default CreateCampaignButton;
